import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useApi } from '../../hooks/useApi';
import { Donor } from '../../models/Donor';

type Props = {
  donor: Donor;
}

const MessageForm = ({ donor }: Props) => {
  const [ content, setContent ] = useState('');
  const { post, loading } = useApi();

  const handleSubmit = (e: React.FormEvent) => {
    if (!content.trim()) {
      toast.error('メッセージを入力してください。');
      return;
    }

    post({
      endpoint: '/api/v1/convs',
      body: {
        donor_no: donor.userNo,
        message_body: content
      },
      onSuccess: () => {
        toast.success('メッセージを送信しました。');
        setContent('');
      },
      onError: (err) => {
        console.error(err);
        toast.error('メッセージの送信に失敗しました。');
      }
    });
  };

  return (
    <>
      <h2 className="main_title"><span>{ donor.initialName } さんにメッセージを送る</span></h2>
      <div className="form">
        <textarea
          value={ content }
          onChange={ e => setContent(e.target.value) }
          placeholder="ドナーへのメッセージを入力してください。&#13;&#10;（例）はじめまして。プロフィールを拝見しました。ぜひ一度お話をお伺いしたいです。"
          rows={ 5 }
          disabled={ loading }
        />
        <input
          type="submit"
          className="w_bluebtn"
          value={ loading ? '送信中...' : '送信する' }
          disabled={ loading }
          onClick={ handleSubmit }
        />
      </div>
    </>
  );
};

export default MessageForm;
